import { render, staticRenderFns } from "./news-latest.vue?vue&type=template&id=3e790ca6&scoped=true&"
import script from "./news-latest.vue?vue&type=script&lang=js&"
export * from "./news-latest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e790ca6",
  null
  
)

export default component.exports